// eslint-disable-next-line import/prefer-default-export
export const API_KEY = 'HjQS5oUddcnOctdVA6_GjREaRRmE0upc11taFSTGNPM'
